import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TablePagination from "@/components/table/pagination";
import { invoiceData } from "@/data/invoice-data";
import { invoiceListColumns } from "./columns";
import Filters from "./filters";

import TableFooter from "@/components/table/footer";
import { exportToCSV } from "@/utils/export-to-csv";
export type InvoiceTableDataType = (typeof invoiceData)[number];

export default function InvoiceTable() {
    const { table, setData } = useTanStackTable<InvoiceTableDataType>({
        tableData: invoiceData,
        columnConfig: invoiceListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                },
            },
            enableColumnResizing: false,
        },
    });

    const selectedData = table
        .getSelectedRowModel()
        .rows.map((row) => row.original);

    function handleExportData() {
        exportToCSV(
            selectedData,
            "ID,Name,Email,DueDate,Status,Amount,CreatedAt",
            `invoice_data_${selectedData.length}`,
        );
    }

    return (
        <>
            <Filters table={table} />
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} onExport={handleExportData} />
            <TablePagination table={table} className="py-4" />
        </>
    );
}
